'use client'

import { Mail } from 'lucide-react'
import { plausible } from '@/lib/plausible'
import { CONTACT_HREF } from '../content'

/**
 * The closing CTA on each partnership page. Still a plain mailto — the whole
 * offer runs through Daisy's inbox and a form would only add a step — with a
 * Plausible event carrying which of the three pages it fired from. Once
 * traffic arrives, that single number says whether workplaces or communities
 * is the real business.
 *
 * A client component only for the click handler; the link itself works with
 * JavaScript off, and the tracking is a no-op if Plausible never loads.
 */
export function PartnerCta({
  page,
  heading,
  blurb,
  action,
}: {
  page: 'hub' | 'workplaces' | 'communities'
  heading: string
  blurb: string
  action: string
}) {
  return (
    <section className="py-[80px] flex flex-col gap-[16px] items-center text-center px-[24px]">
      <h2 className="text-xxl font-bold max-w-[560px]">{heading}</h2>
      <p className="text-l font-light max-w-[560px]">{blurb}</p>
      <a
        href={CONTACT_HREF}
        onClick={() => plausible.partnerCtaClicked(page)}
        className="mt-[8px] inline-flex items-center gap-[10px] px-[24px] py-[14px] bg-[#1A1A1A] text-[#F7F1E7] rounded-full text-l font-bold hover:opacity-90 transition-opacity focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[#5F875E]"
      >
        <Mail size={20} strokeWidth={2} aria-hidden="true" />
        {action}
      </a>
    </section>
  )
}
